import VersionChangedModal from "./VersionChangedModal";

export default VersionChangedModal;
